import {
  Component,
  EventEmitter,
  Output,
  Input,
  ViewChild,
  ElementRef,
  OnInit,
  Sanitizer,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "environments/environment";

@Component({
  selector: "app-cropper-image",
  templateUrl: "./app-cropper-image.component.html",
})
export class AppCropperImageComponent implements OnInit {
  public data: any;
  public isValid = false;
  @ViewChild("fileInput") fileInput: ElementRef;
  @Output() imgSelected: EventEmitter<any> = new EventEmitter<any>();
  @Input() format = "post";
  @Input() loading: string;

  public imageChangedEvent: any = "";
  public croppedImage: any = "";
  public maintainAspectRatio = true;
  public resizeToWidth = 0;
  public resizeToHeight = 0;
  public aspectRatio: number;

  constructor(private sanitizer: DomSanitizer) {}

  get croppedImageBg() {
    return this.sanitizer.bypassSecurityTrustStyle(
      "url(" + this.croppedImage + ")"
    );
  }

  ngOnInit() {
    this.aspectRatio = 16 / 9;
    // this.aspectRatio = 4 / 3;

    if (this.format === "free") {
      this.maintainAspectRatio = false;
    }
    if (this.format === "cover") {
      // this.aspectRatio = 4 / 1;
      this.aspectRatio = 16 / 9;
    }
    if (this.format === "poll") {
      this.aspectRatio = 16 / 18;
    }
    if (this.format === "logo") {
      this.aspectRatio = 1 / 1;
    }
    this.clicked();
  }

  fileChangeEvent(event: any): void {
    const fsize = event.currentTarget.files[0].size;
    const file = Math.round(fsize / 1024);
    if (file >= 5120) {
      alert("File too Big, please select a file less than 5mb");
      return;
    }
    this.imageChangedEvent = event;
    this.isValid = false;
  }

  imageCropped(image: any) {
    this.croppedImage = image.base64;
    // console.log(image.width, image.height);
    setTimeout(() => {
      this.isValid = true;
    }, 1000);
  }
  loadImageFailed(e) {
    // show message
    console.log("Error", e);
  }

  onSelectImage() {
    // console.log(this.croppedImage);
    this.imgSelected.emit(this.croppedImage);
  }

  clicked() {
    this.fileInput.nativeElement.click();
  }
}
